module.exports = __webpack_public_path__ + "img/sustainable_energy.45bb3b07.svg";